module.exports = __webpack_public_path__ + "img/家阳台.23398d68.png";